import { authClient } from '../initialization'

/**
 * Revokes the auth token.
 */
export async function logOut() {
  await authClient.logout()
}
